module.exports = __webpack_public_path__ + "static/media/kokun.9c81f7f9.png";